// SRP Page
import React, { useEffect } from 'react'
import { Container, Unstable_Grid2 as Grid } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import DefaultLayout from '@src/components/DefaultLayout'
import CompareDrawer from '@src/components/CompareDrawer/CompareDrawer'
import { sendViewSearchResultsEvent } from '@src/utils/analytics'
import SearchResultsHead from './SearchResultsHead'
import SearchFacets from './SearchFacets'
import SearchResults from './SearchResults'
import SearchProvider, { useSearchContext } from './SearchContext'
import { useRouter } from '@src/routes'
import { AnalyticsDispType } from '@src/types/graphql-types'
import RecentlyViewedCarouselTestWrapper from '@src/components/RecentlyViewedProductsCarousel/RecentlyViewedCarouselTestWrapper'

const useStyles = makeStyles()((theme) => ({
  searchContainer: {
    [theme.breakpoints.down('sm')]: {
      overflowX: 'hidden',
    },
    [theme.breakpoints.up('xs')]: {
      borderTop: 0,
    },
  },
  searchFacetsContainer: {
    maxWidth: '290px',
  },
  searchGridContainer: {
    [theme.breakpoints.up('lg')]: {
      justifyContent: 'space-between',
    },
  },
  searchResultsContainer: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing(10),
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: '950px',
      paddingLeft: theme.spacing(0),
    },
  },
  resultsContainer: {
    marginBottom: theme.spacing(10),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(8),
    },
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(7, 0, 0, 0),
    },
    marginTop: theme.spacing(5),
  },
  recentlyViewedProducts: {
    borderTop: `solid 1px ${theme.palette.grey[400]}`,
  },
}))

const SearchContent: React.FC = () => {
  const { classes } = useStyles()
  const { metadata, loading, productResults } = useSearchContext()
  const router = useRouter()
  const { focus, searchTerm, page } = router?.query

  useEffect(() => {
    if (!loading) {
      if (productResults === undefined) return
      const searchResultStatus = productResults ? 'standard' : 'no results page'

      sendViewSearchResultsEvent({
        qFocus: focus || '',
        qPage: page || '',
        qType: focus || '',
        searchResultStatus,
        searchTerm: searchTerm ?? '',
        searchResultsCount: metadata?.count,
      })
    }
  }, [loading, focus, metadata?.count, page, searchTerm, productResults])

  return (
    <DefaultLayout className={classes.searchContainer}>
      <Container maxWidth="lg" classes={{ root: classes.resultsContainer }}>
        <SearchResultsHead key="head" metadata={metadata} />
        <Grid container className={classes.searchGridContainer}>
          <Grid className={classes.searchFacetsContainer} md={3}>
            <SearchFacets />
          </Grid>
          <Grid className={classes.searchResultsContainer} xs={12} md={9}>
            <SearchResults />
          </Grid>
        </Grid>
        <Grid xs={12} className={classes.recentlyViewedProducts}>
          <RecentlyViewedCarouselTestWrapper
            dispType={AnalyticsDispType.RecentlyViewedSrp}
          />
        </Grid>
      </Container>
      <CompareDrawer />
    </DefaultLayout>
  )
}

const SearchResultsPage: React.FC = () => {
  return (
    <SearchProvider>
      <SearchContent />
    </SearchProvider>
  )
}

export default SearchResultsPage
